import React from "react";
import ReportAProblem from "./ReportAProblem";
import UserProfile from "./UserProfile";
import Locations from "./Locations";
import FacilityStaff from "./FacilityStaff";
import FacilityLocationGroup from "./FacilityLocationGroup";
import PracticeStaff from "./PracticeStaff";

const componentMapper = {
  report_a_problem: ReportAProblem,
  user_profile: UserProfile,
  locations: Locations,
  facility_staff: FacilityStaff,
  practice_staff: PracticeStaff,
  facility_location_groups: FacilityLocationGroup,
};

function SettingsContent({ activeTab = "", setActiveTab = () => {} }) {
  const ActiveComponent = componentMapper[activeTab] || null;

  return (
    <div className="w-full min-h-full">
      {ActiveComponent ? (
        <ActiveComponent />
      ) : (
        <div className="flex items-center justify-center min-h-[200px] text-gray-500 text-sm">
          No component available
        </div>
      )}
    </div>
  );
}

export default SettingsContent;
